module.exports = __webpack_public_path__ + "media/images/home-bar-125de9c162fbd5a806a63b408b8c4c4a.png";